import { FormattedMessage } from 'react-intl'
import SpreadsheetTable from '@components/SpreadsheetTable/SpreadsheetTable'
import { DataRow } from 'src/types/tableDataSet'
import { useQueryData } from '@hooks/useQuery'
import { useTrialGuard } from '@hooks/useTrialGuard'

import emptyImage from '@static/images/resource-list/no-items.jpg'

export const QueryNoRunYet = ({
  onRun,
  isLoading
}: {
  onRun: () => void
  isLoading: boolean
}) => {
  const { guard } = useTrialGuard()
  return (
    <div id="query-not-run">
      <img src={emptyImage} alt="" aria-hidden="true" />
      <h2>
        <FormattedMessage id="query-result.not-run-yet" />
      </h2>
      <button
        className="highlight-button"
        onClick={guard(onRun)}
        disabled={isLoading}
      >
        <span
          className={`icon ${isLoading ? 'icon-play-filled' : 'icon-play-stroke'}`}
        />
        <span>
          <FormattedMessage id={isLoading ? 'running' : 'run'} />
        </span>
      </button>
    </div>
  )
}

export default function QueryResult({
  id,
  onRun,
  isLoading
}: {
  id: string
  onRun: () => void
  isLoading: boolean
}) {
  const { data, colSpec } = useQueryData(id)
  const { guard } = useTrialGuard()

  if (data === null)
    return <QueryNoRunYet onRun={guard(onRun)} isLoading={isLoading} />

  const rows: DataRow[] = data.map((row) =>
    colSpec.map((col) => row[col.name] ?? null)
  )

  return (
    <div id="query-result">
      <h2>
        <FormattedMessage id="query-result.title" />
      </h2>
      <div id="query-result-info">
        {rows.length === 0 ? (
          <div id="table-data-set" className="empty-data">
            <h2>
              <FormattedMessage id="dataset.table-data.empty" />
            </h2>
          </div>
        ) : (
          <SpreadsheetTable
            columnsDef={colSpec}
            rows={rows}
            idColumnIndex={0}
          />
        )}
      </div>
    </div>
  )
}
